"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateConsentMetaDoc = void 0;
var types_1 = require("../types");
// An update to whats on consent meta docs has taken place in the termintion followup call release for surveysaurus
// All calendly calls now extend or implement the IScheduleCall interface
// ** OLD ConsetMeta inteface **
// export interface IConsent {
//   docPath: string;
//   employeeName: string;
//   notes: string;
//   preConsentStatus: ConsentStatus;
//   updated: Date;
//   dateOfCall: Date | null;
//   eventURI: string | null;
//   inviteeURI: string | null;
//   callStartTime: Date | null;
//   callEndTime: Date | null;
//   locationInfo: any | null;
//   cancelURL: string | null;
//   rescheduleURL: string | null;
//   consentFormEnvelopeID: string;
//   consentFormStatus: string;
// }
// ** NEW ConsentMeta interface **
// export interface IConsentMeta extends IScheduleCall {
//   employeeName: string;
//   notes: string;
//   preConsentStatus: ConsentStatus;
//   consentFormEnvelopeID: string;
//   consentFormStatus: string;
// }
// ** IScheduleCall interface at the time of this release
// export interface IScheduleCall extends ScheduleCallOption {
//   status: ScheduledCallStatus;
//   created: Date;
//   workflowType: WorkflowType;
//   dateOfCall?: Date | null;
//   eventURI?: string | null;
//   inviteeURI?: string | null;
//   callStartTime?: Date | null;
//   callEndTime?: Date | null;
//   locationInfo?: any | null;
//   cancelURL?: string | null;
//   rescheduleURL?: string | null;
// }
// ** ScheduleCallOption interface at the time of this relase
// export interface ScheduleCallOption {
//   description: string;
//   title: string;
//   // Name of the calendly event from calendly
//   eventName: string;
//   required: boolean;
//   calendlyCallURL: string;
//   therapyWeek?: number;
// }
var migrateConsentMetaDoc = function (consentMeta, workflowType) {
    if (!consentMeta.status) {
        // Need to migrate users to new version of consent meta doc interface that contains
        // a preConsentStatus and a call status ('status')
        // Old version of consent meta just had a preConsentStatus 
        // But now the consentMeta doc needs to extend the IScheduledCalls interface
        if (consentMeta.preConsentStatus === types_1.ConsentStatus.APPROVED) {
            consentMeta.status = types_1.ScheduledCallStatus.COMPLETED;
        }
        else if (consentMeta.preConsentStatus === types_1.ConsentStatus.FAILED_APPROVAL) {
            consentMeta.status = types_1.ScheduledCallStatus.COMPLETED;
        }
        else if (consentMeta.preConsentStatus === types_1.ConsentStatus.NOT_APPROVED && consentMeta.callStartTime) {
            consentMeta.status = types_1.ScheduledCallStatus.CALL_SCHEDULED;
        }
        else if (consentMeta.preConsentStatus === types_1.ConsentStatus.NOT_APPROVED) {
            consentMeta.status = types_1.ScheduledCallStatus.NOT_SCHEDULED;
        }
        else if (consentMeta.preConsentStatus === types_1.ConsentStatus.ABANDONED) {
            consentMeta.status = types_1.ScheduledCallStatus.ABANDONED;
        }
        // The following status was removed from preConsentStatus 
        // and is now handled by the call status
        else if (consentMeta.preConsentStatus === 'call-scheduled') {
            consentMeta.status = types_1.ScheduledCallStatus.CALL_SCHEDULED;
            consentMeta.preConsentStatus = types_1.ConsentStatus.NOT_APPROVED;
        }
    }
    if (!consentMeta.calendlyCallURL) {
        // Need to add in calendlyCallURL to old consent meta docs, it was hard coded before with the below ConsentCallURI object
        // New version of consent meta doc has this field on the document itself
        consentMeta.calendlyCallURL = ConsentCallURI[workflowType];
    }
    return consentMeta;
};
exports.migrateConsentMetaDoc = migrateConsentMetaDoc;
// This is to fill in the call url for old consent meta docs
var ConsentCallURI = (_a = {},
    _a[types_1.WorkflowType.STANDARD] = 'https://calendly.com/d/m24v-4n9j/screening-call-informed-consent',
    _a[types_1.WorkflowType.EXTENSION] = 'https://calendly.com/d/chg-25c-7xv/react-fm-ext-consent-call',
    _a);
